import { render, staticRenderFns } from "./ExpandableFragment.vue?vue&type=template&id=8c580c26&scoped=true"
import script from "./ExpandableFragment.vue?vue&type=script&lang=ts"
export * from "./ExpandableFragment.vue?vue&type=script&lang=ts"
import style0 from "./ExpandableFragment.vue?vue&type=style&index=0&id=8c580c26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c580c26",
  null
  
)

export default component.exports